import React from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays, ChevronRight } from "lucide-react";
import { useDevices } from "@/hooks/useDevices";
import {
  PageHeader, DataTable, EmptyState, DeviceStatusBadge, type Column,
} from "@/components/ui";
import type { DeviceSummary } from "@/api/devices";

// Org-wide sampling-schedule entry. Schedules are weekly per device; this lists
// the fleet and links into each device's schedule editor.
export function OrgSchedule() {
  const navigate = useNavigate();
  const { data, isLoading } = useDevices();
  const devices = data?.devices ?? [];

  const columns: Column<DeviceSummary>[] = [
    { key: "name", header: "Device", render: (d) => d.label ?? d.serial_number },
    { key: "model", header: "Model", render: (d) => d.model },
    { key: "status", header: "Status", render: (d) => <DeviceStatusBadge online={d.is_online} /> },
    {
      key: "go", header: "", align: "right",
      render: () => <ChevronRight size={16} className="text-textLight inline" />,
    },
  ];

  return (
    <div className="space-y-md">
      <PageHeader title="Schedule" subtitle="Weekly sampling schedule per device" icon={CalendarDays} />
      {!isLoading && devices.length === 0 ? (
        <EmptyState title="No devices" icon={CalendarDays} />
      ) : (
        <DataTable
          columns={columns}
          rows={devices}
          getRowKey={(d) => d.id}
          loading={isLoading}
          onRowClick={(d) => navigate(`/devices/${d.id}/schedule`)}
        />
      )}
    </div>
  );
}

export default OrgSchedule;
